document.addEventListener('DOMContentLoaded', function () {
  // fallback delay
  setTimeout(() => {
    const stickyATC = document.querySelector('sticky-atc.form.product-form.flex');
    if (stickyATC) stickyATC.style.display = 'flex';
  }, 1500);

  // live watcher
  const observer = new MutationObserver(() => {
    const stickyATC = document.querySelector('sticky-atc.form.product-form.flex');
    if (stickyATC) {
      stickyATC.style.display = 'flex';
      observer.disconnect();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});
